import Global from "../config/config.json";
import httpService from "../config/httpService";
const assistAPI= {
    async addAssist(data,jwt) {
        let res = [];
        await httpService
            .post(`${Global.Nameh}assist/add`,{assists:data}
            ,{
                headers:{Authorization: `${jwt.token_type} ${jwt.access_token}`}
            })
            .then((json) => {
                switch (json.status) {
                    case 200:
                        res = json.data
                        break;
                        
                }
            })
        return res;
    },
    async assists(jwt) {
        let res = [];
        await httpService
            .get(`${Global.Nameh}assist/get`
            ,{
                headers:{Authorization: `${jwt.token_type} ${jwt.access_token}`}
            })
            .then((json) => {
                switch (json.status) {
                    case 200:
                        res = json.data
                        break;
                        
                }
            })
        return res;
    }
}
export default assistAPI;